export class preFlightInfo {
  constructor() {
    this.fNameList = null;
    this.fSCM = null;
    this.fPLM = null;
    this.fCanvasPanel = null;
    this.fPubPanel = null;
    this.fShowSCNum = null;
    this.fNumPages = null;
    this.fPageIndex = null;
    this.fOutputType = null;
  }
}
